// extracted by mini-css-extract-plugin
export default {"archivo":"StyledSpan-module__archivo___UouIY"};